import React from 'react';

export default function Users() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49984 1.6665C5.3165 1.6665 3.5415 3.4415 3.5415 5.62484C3.5415 7.7665 5.2165 9.49984 7.39984 9.57484C7.4665 9.5665 7.53317 9.5665 7.58317 9.57484C7.59984 9.57484 7.60817 9.57484 7.62484 9.57484C7.63317 9.57484 7.63317 9.57484 7.6415 9.57484C9.77484 9.49984 11.4498 7.7665 11.4582 5.62484C11.4582 3.4415 9.68317 1.6665 7.49984 1.6665Z"
        fill="#A6A6A6"
      />
      <path
        d="M11.7333 11.7919C9.4083 10.2419 5.61663 10.2419 3.27497 11.7919C2.21663 12.5002 1.6333 13.4586 1.6333 14.4836C1.6333 15.5086 2.21663 16.4586 3.26663 17.1586C4.4333 17.9419 5.96663 18.3336 7.49997 18.3336C9.0333 18.3336 10.5666 17.9419 11.7333 17.1586C12.7833 16.4502 13.3666 15.5002 13.3666 14.4669C13.3583 13.4419 12.7833 12.4919 11.7333 11.7919Z"
        fill="#A6A6A6"
      />
      <path
        d="M16.6588 6.11659C16.7921 7.73325 15.6421 9.14992 14.0505 9.34159C14.0421 9.34159 14.0421 9.34159 14.0338 9.34159H14.0088C13.9588 9.34159 13.9088 9.34159 13.8671 9.35825C13.0588 9.39992 12.3171 9.14159 11.7588 8.66659C12.6171 7.89992 13.1088 6.74992 13.0088 5.49992C12.9505 4.82492 12.7171 4.20825 12.3671 3.68325C12.6838 3.52492 13.0505 3.42492 13.4255 3.39159C15.0588 3.24992 16.5171 4.46659 16.6588 6.11659Z"
        fill="#737373"
      />
      <path
        d="M18.3249 13.8252C18.2582 14.6335 17.7415 15.3335 16.8749 15.8085C16.0415 16.2668 14.9915 16.4835 13.9499 16.4585C14.5499 15.9168 14.8999 15.2418 14.9665 14.5252C15.0499 13.4918 14.5582 12.5002 13.5749 11.7085C13.0165 11.2668 12.3665 10.9168 11.6582 10.6585C13.4999 10.1252 15.8165 10.4835 17.2415 11.6335C18.0082 12.2502 18.3999 13.0252 18.3249 13.8252Z"
        fill="#737373"
      />
    </svg>
  );
}
